/* eslint-disable jsx-a11y/anchor-is-valid */
import {ReactComponent as StarIcon} from 'assets/icons/star.svg';
import styles from './Footer.module.scss';
import Logo from 'components/Logo';

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.container}>
      <div className={styles.grid}>
        <div className={styles.brandColumn}>
          <div className={styles.brand}>
            <div className={styles.logo}>
              <Logo style={{width: 25, height: 25, filter: 'invert(0)'}} />
            </div>
            <span className={styles.brandName}>Magic Dispatch</span>
          </div>
          <p className={styles.description}>
            Turn customer requests and orders into dispatchable jobs & tasks on
            the go
          </p>
          <div className={styles.socialLinks}>
            <div className={styles.socialIcon}>
              <StarIcon className={styles.starIcon} />
            </div>
          </div>
        </div>
        <div className={styles.column}>
          <h4 className={styles.columnTitle}>Solutions</h4>
          <ul className={styles.linkList}>
            <li>
              <a href="#" className={styles.link}>
                Property Managers
              </a>
            </li>
            <li>
              <a href="#" className={styles.link}>
                Field Service
              </a>
            </li>
            <li>
              <a href="#" className={styles.link}>
                Delivery
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.column}>
          <h4 className={styles.columnTitle}>Features</h4>
          <ul className={styles.linkList}>
            <li>
              <a href="#" className={styles.link}>
                AI Scheduling
              </a>
            </li>
            <li>
              <a href="#" className={styles.link}>
                Team Dispatch
              </a>
            </li>
            <li>
              <a href="#" className={styles.link}>
                Performance Tracking
              </a>
            </li>
            <li>
              <a href="#" className={styles.link}>
                Payment Processing
              </a>
            </li>
          </ul>
        </div>
        <div className={styles.column}>
          <h4 className={styles.columnTitle}>Support</h4>
          <ul className={styles.linkList}>
            <li>
              <a href="#" className={styles.link}>
                Help Center
              </a>
            </li>
            <li>
              <a href="#" className={styles.link}>
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>&copy; 2025 Magic Dispatch. All rights reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
